'use client';
import React from 'react';
import Link from 'next/link';
import { Home, AlertCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4 text-center font-sans" dir="rtl">
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="bg-white rounded-3xl p-12 shadow-xl max-w-lg w-full border border-gray-100"
            >
                <div className="w-24 h-24 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
                    <AlertCircle size={48} className="text-red-500" />
                </div>

                <h1 className="text-6xl font-black text-gray-900 mb-2">404</h1>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">الصفحة غير موجودة</h2>

                <p className="text-gray-500 mb-8 leading-relaxed">
                    عذراً، الصفحة التي تحاول الوصول إليها قد تكون حذفت أو تم تغيير رابطها أو غير متوفرة حالياً.
                </p>

                <Link
                    href="/"
                    className="inline-flex items-center gap-2 bg-primary text-white px-8 py-3 rounded-xl font-bold hover:bg-opacity-90 transition-all hover:scale-105 shadow-lg shadow-primary/20"
                >
                    <Home size={20} />
                    العودة للرئيسية
                </Link>
            </motion.div>
        </div>
    );
};

export default NotFound;
